import request from '@/utils/request'

export function getList(params) {
  return request({
    url: '/talkEvents/load',
    method: 'get',
    params
  })
}


